import { useCallback, KeyboardEvent } from "react";

export const useKeyboardAction = (action: () => void) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        action();
      }
    },
    [action]
  );

  return handleKeyDown;
};
